import { render } from "./calendar-icon-svg.vue?vue&type=template&id=3a3a95d9&ts=true"
import script from "./calendar-icon-svg.vue?vue&type=script&lang=ts"
export * from "./calendar-icon-svg.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__